import React from "react";
import { FaTwitter, FaLinkedin, FaAngellist, FaGithub } from "react-icons/fa";

const Navbar = (props) => {
  const links = [
    {
      url: "#about",
      name: "About",
    },
    {
      url: "#projects",
      name: "Projects",
    },
    {
      url: "#services",
      name: "Services",
    },
    {
      url: "#skills",
      name: "Skills",
    },
  ];
  const socials = [
    {
      link: "https://twitter.com/devaladdin",
      name: "Twiter",
      logo: <FaTwitter />,
    },
    {
      link: "https://www.linkedin.com/in/inaolaji-taofeek-64587b169",
      name: "Linkedin",
      logo: <FaLinkedin />,
    },
    {
      link: "https://angel.co/u/taofeek-akinkunmi",
      name: "Wellfound",
      logo: <FaAngellist />,
    },
    {
      link: "https://github.com/aladdin4u",
      name: "Github",
      logo: <FaGithub />,
    },
  ];
  return (
    <nav className="sticky top-0 inset-x-0 bg-black bg-gradient-to-tl from-zinc-900 via-zinc-400/10 to-zinc-900">
      <div className="mx-auto max-w-full px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <span className="flex flex-1 items-center justify-start">
            <svg
              className="w-full lg:w-1/2 shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 300 300"
            >
              <defs data-v-fde0c5aa=""></defs>
              <rect
                data-v-fde0c5aa=""
                fill="transparent"
                x="0"
                y="0"
                width="300px"
                height="300px"
                className="logo-background-square"
              ></rect>
              <defs data-v-fde0c5aa=""></defs>
              <g
                data-v-fde0c5aa=""
                id="4c253786-08ca-4c03-a14f-d58171d1c408"
                fill="#f5f5f5"
                transform="matrix(2.0787725023876544,0,0,2.0787725023876544,117.08439616045557,134.64826508969188)"
              >
                <path d="M2.84 2.80L1.12 12.60L4.06 12.60C5.81 12.60 7.22 12.07 8.30 11.00C9.38 9.94 9.93 8.55 9.93 6.83C9.93 5.66 9.53 4.69 8.75 3.93C7.97 3.18 6.98 2.80 5.78 2.80ZM3.86 3.92L5.59 3.92C6.55 3.92 7.31 4.19 7.87 4.72C8.43 5.25 8.71 5.97 8.71 6.87C8.71 8.23 8.27 9.33 7.41 10.19C6.54 11.05 5.49 11.48 4.26 11.48L2.53 11.48ZM15.76 8.71L11.87 8.71C12.02 8.21 12.32 7.80 12.75 7.48C13.19 7.16 13.67 7.00 14.20 7.00C14.63 7.00 15.01 7.13 15.32 7.38C15.64 7.64 15.79 7.99 15.79 8.43C15.79 8.48 15.78 8.58 15.76 8.71ZM11.68 9.66L16.74 9.66C16.84 9.29 16.88 8.91 16.88 8.53C16.88 7.82 16.64 7.22 16.16 6.74C15.68 6.26 15.08 6.02 14.36 6.02C13.37 6.02 12.54 6.33 11.87 6.95C11.19 7.57 10.76 8.38 10.58 9.38C10.54 9.66 10.51 9.90 10.51 10.11C10.51 10.90 10.74 11.54 11.21 12.02C11.67 12.50 12.30 12.74 13.09 12.74C13.86 12.74 14.49 12.60 14.98 12.33C15.47 12.06 15.94 11.65 16.39 11.10L15.55 10.47C14.90 11.28 14.14 11.69 13.27 11.69C12.20 11.69 11.66 11.13 11.66 10.00C11.66 9.85 11.67 9.73 11.68 9.66ZM17.86 6.16L19.73 13.09L24.02 6.16L22.69 6.16L20.10 10.42L19.12 6.16ZM29.90 6.16L29.71 7.31C29.54 6.91 29.28 6.59 28.94 6.36C28.59 6.13 28.19 6.02 27.73 6.02C26.74 6.02 25.84 6.40 25.06 7.16C24.28 7.92 23.88 8.90 23.88 10.09C23.88 10.91 24.13 11.55 24.63 12.03C25.12 12.50 25.76 12.74 26.54 12.74C27.49 12.74 28.29 12.32 28.97 11.49L28.77 12.60L29.89 12.60L31.02 6.16ZM25.07 9.88C25.07 9.09 25.34 8.42 25.88 7.88C26.42 7.34 27.02 7.07 27.69 7.07C28.16 7.07 28.56 7.22 28.89 7.52C29.22 7.82 29.39 8.25 29.39 8.81C29.39 9.64 29.11 10.32 28.55 10.87C27.99 11.42 27.38 11.69 26.73 11.69C26.24 11.69 25.84 11.54 25.54 11.24C25.23 10.94 25.07 10.49 25.07 9.88ZM33.85 1.68L31.92 12.60L33.04 12.60L34.97 1.68ZM41.10 6.16L40.91 7.31C40.74 6.91 40.48 6.59 40.14 6.36C39.79 6.13 39.39 6.02 38.93 6.02C37.94 6.02 37.04 6.40 36.26 7.16C35.48 7.92 35.08 8.90 35.08 10.09C35.08 10.91 35.33 11.55 35.83 12.03C36.32 12.50 36.96 12.74 37.74 12.74C38.69 12.74 39.49 12.32 40.17 11.49L39.97 12.60L41.09 12.60L42.22 6.16ZM36.27 9.88C36.27 9.09 36.54 8.42 37.08 7.88C37.62 7.34 38.22 7.07 38.89 7.07C39.36 7.07 39.76 7.22 40.09 7.52C40.42 7.82 40.59 8.25 40.59 8.81C40.59 9.64 40.31 10.32 39.75 10.87C39.19 11.42 38.58 11.69 37.93 11.69C37.44 11.69 37.04 11.54 36.74 11.24C36.43 10.94 36.27 10.49 36.27 9.88ZM49.88 1.68L48.89 7.27C48.54 6.44 47.88 6.02 46.91 6.02C45.92 6.02 45.02 6.40 44.24 7.16C43.46 7.92 43.06 8.90 43.06 10.09C43.06 10.91 43.31 11.55 43.81 12.03C44.30 12.50 44.94 12.74 45.72 12.74C46.67 12.74 47.47 12.32 48.15 11.49L47.95 12.60L49.07 12.60L51.00 1.68ZM44.25 9.88C44.25 9.09 44.52 8.42 45.06 7.88C45.60 7.34 46.20 7.07 46.87 7.07C47.34 7.07 47.74 7.22 48.07 7.52C48.40 7.82 48.57 8.25 48.57 8.81C48.57 9.64 48.29 10.32 47.73 10.87C47.17 11.42 46.56 11.69 45.91 11.69C45.42 11.69 45.02 11.54 44.72 11.24C44.41 10.94 44.25 10.49 44.25 9.88ZM57.86 1.68L56.87 7.27C56.52 6.44 55.86 6.02 54.89 6.02C53.90 6.02 53.00 6.40 52.22 7.16C51.44 7.92 51.04 8.90 51.04 10.09C51.04 10.91 51.29 11.55 51.79 12.03C52.28 12.50 52.92 12.74 53.70 12.74C54.65 12.74 55.45 12.32 56.13 11.49L55.93 12.60L57.05 12.60L58.98 1.68ZM52.23 9.88C52.23 9.09 52.50 8.42 53.04 7.88C53.58 7.34 54.18 7.07 54.85 7.07C55.32 7.07 55.72 7.22 56.05 7.52C56.38 7.82 56.55 8.25 56.55 8.81C56.55 9.64 56.27 10.32 55.71 10.87C55.15 11.42 54.54 11.69 53.89 11.69C53.40 11.69 53.00 11.54 52.70 11.24C52.39 10.94 52.23 10.49 52.23 9.88ZM60.69 3.50C60.69 3.71 60.76 3.88 60.91 4.04C61.06 4.19 61.25 4.27 61.46 4.27C61.67 4.27 61.86 4.19 62.01 4.04C62.16 3.88 62.23 3.71 62.23 3.50C62.23 3.29 62.16 3.12 62.01 2.96C61.86 2.81 61.67 2.73 61.46 2.73C61.25 2.73 61.06 2.81 60.91 2.96C60.76 3.12 60.69 3.29 60.69 3.50ZM60.40 6.16L59.26 12.60L60.44 12.60L61.57 6.16ZM64.55 8.57C64.66 8.13 64.88 7.77 65.23 7.49C65.58 7.21 65.99 7.07 66.46 7.07C66.85 7.07 67.14 7.14 67.33 7.29C67.51 7.43 67.61 7.68 67.61 8.04C67.61 8.16 67.58 8.37 67.54 8.68L66.85 12.60L67.97 12.60L68.68 8.54C68.73 8.26 68.75 8.03 68.75 7.85C68.75 7.26 68.59 6.80 68.27 6.49C67.95 6.18 67.50 6.02 66.92 6.02C66.12 6.02 65.42 6.36 64.82 7.03L64.97 6.16L63.85 6.16L62.72 12.60L63.84 12.60Z"></path>
              </g>
              <defs data-v-fde0c5aa="">
                <linearGradient
                  data-v-fde0c5aa=""
                  gradientTransform="rotate(25)"
                  id="8329c4d9-3667-4497-8813-7212e23c81e7"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop
                    data-v-fde0c5aa=""
                    offset="0%"
                    stopColor="#4E1A70"
                    stopOpacity="1"
                  ></stop>
                  <stop
                    data-v-fde0c5aa=""
                    offset="100%"
                    stopColor="#2B4CF2"
                    stopOpacity="1"
                  ></stop>
                </linearGradient>
              </defs>
              <g
                data-v-fde0c5aa=""
                id="88ecf5cd-aeed-42e2-912c-426348eef841"
                stroke="none"
                fill="url(#8329c4d9-3667-4497-8813-7212e23c81e7)"
                transform="matrix(2.1562539940952385,0,0,2.1562539940952385,30.08122874825223,106.7671090634817)"
              >
                <path
                  clipRule="evenodd"
                  d="M26.7 13.4L25.2 16l6.6 4-6.6 4 1.5 2.6 8.7-5.3v-2.6l-8.7-5.3zm-13.4 0l-8.7 5.3v2.6l8.7 5.3 1.5-2.6-6.6-4 6.6-4-1.5-2.6zm3 14.2l2.9.7 3.5-15.8-2.9-.7-3.5 15.8z"
                ></path>
              </g>
            </svg>
          </span>
            <div className="hidden sm:block">
              <div className="flex space-x-4">
                {links &&
                  links.map((link) => (
                    <a
                      key={link.name}
                      href={link.url}
                      aria-label={link.name}
                      rel="noopener"
                      className="text-zinc-400 hover:bg-zinc-800 hover:text-zinc-300 px-3 py-2 rounded-md text-sm font-medium"
                    >
                      {link.name}
                    </a>
                  ))}
              </div>
            </div>
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-end">
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-2">
                {socials &&
                  socials.map((social) => (
                    <a
                      href={social.link}
                      key={social.link}
                      target="_blank"
                      aria-label={social.name}
                      rel="noopener"
                      className="text-zinc-400 hover:bg-zinc-800 hover:text-zinc-300 px-3 py-2 rounded-md text-sm font-medium"
                    >
                      {social.logo}
                    </a>
                  ))}
              </div>
            </div>
            <div
              className="absolute inset-y-0 right-0 flex items-center sm:hidden"
            >
              {/* <!-- Mobile menu button--> */}
              <button
                type="button"
                className="inline-flex items-center justify-center rounded-md p-2 text-zinc-400 hover:bg-zinc-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
                onClick={props.toggle}
              >
                <span className="sr-only">Open main menu</span>
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d={props.mobile ? "M6 18L18 6M6 6l12 12":"M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"}
                      
                    />
                  </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Mobile menu, show/hide based on menu state. --> */}
      <div
        className={`sm:hidden ${props.mobile ? "" : "hidden"}`}
        id="mobile-menu"
      >
        <div className="space-y-1 px-2 pt-2 pb-3">
          {links &&
            links.map((link) => (
              <a
                key={link.name}
                href={link.url}
                aria-label={link.name}
                rel="noopener"
                className="block text-zinc-400 hover:bg-zinc-800 hover:text-zinc-300 px-3 py-2 rounded-md text-sm font-medium"
                onClick={props.toggle}
              >
                {link.name}
              </a>
            ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
